/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    declare var joint: any;

    export const enum WorkflowMode {
        Workflow = 0,
        ProcessAction = 1
    }

    export class WorkflowConfigurationModel {

        private elementMapping: models.jointJs.ElementMap[];
        private processStatusGroups: models.ProcessStatusGroup[];
        
        private isReadonly: boolean;
        private drawingOptions: models.jointJs.DrawingOptions;
        private graph: joint.dia.Graph;
        private paper: joint.dia.Paper;
        
        public workflowWorkspaceModel: models.WorkflowWorkspaceModel;

        constructor(
            private $scope: controllers.IWorkflowConfigurationScope,
            private $timeout: ng.ITimeoutService,
            private processConfigId: string,
            private workflowMode: WorkflowMode,
            private workflowService: services.WorkflowService,
            private deleteService: services.DeleteService,
            public workflowDrawingService: services.WorkflowDrawingService,
            private modalService: any)
        {
            this.$scope = $scope;
            this.$timeout = $timeout;

            this.processStatusGroups = [];
            this.processConfigId = processConfigId;
            this.workflowDrawingService = workflowDrawingService;
            this.workflowService = workflowService;

            if (this.workflowMode === WorkflowMode.Workflow) {
                this.workflowService.getAllStatusGroups(this.processConfigId).then(
                    (processStatusGroupResult) => {
                        this.initialize(processStatusGroupResult.processStatusGroups, processStatusGroupResult.isReadonly);
                    });
            }

            var settings = this.getWorkflowWorkspaceSettings();

            this.workflowWorkspaceModel = new models.WorkflowWorkspaceModel(
                settings,
                this.workflowMode,
                (blocks: models.IWorkflowBlock[]) => this.statusFlowChangedCallback(blocks));
        }

        public getAllowedStatusChanges(): models.ProcessStatusGroup[] {
            if (!this.workflowWorkspaceModel.getSelectedStatusGroup()) return this.processStatusGroups;
            return Enumerable
                .from(this.processStatusGroups)
                .where(i => i.processStatusGroupDto.id !== this.workflowWorkspaceModel.getSelectedStatusGroup().processStatusGroupDto.id)
                .toArray();
        }

        public addStatusChange(index: number) {
            var processStatusGroupSelected = this.getAllowedStatusChanges()[index];
            alert(processStatusGroupSelected.processStatusGroupDto.statusName);
        }

        public statusFlowChangedCallback(blocks: models.IWorkflowBlock[]): void {
            this.updateSelectedStatusGroup(blocks);
            this.redrawConnections();
        }

        public editSelectedStatus(): void {
            this.showAddEditStatusModal(true);
        }

        public addStatus(): void {
            this.showAddEditStatusModal(false);
        }

        public addNewStatus(newStatus: Wars.Domain.Model.Dtos.Workflow.StatusDto): void {
            this.workflowService.addNewStatus(newStatus, this.processConfigId).then(
                (processStatusGroup) => {
                    this.processStatusGroups.push(processStatusGroup);
                    this.draw();
                });
        }

        public deleteStatusCode(statusCodeId: string): void {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "StatusCode",
                statusCodeId,
                "Status successfully deleted",
                () => {
                    this.processStatusGroups = Enumerable
                        .from(this.processStatusGroups)
                        .where(i => i.processStatusGroupDto.id !== statusCodeId)
                        .toArray();

                    this.workflowWorkspaceModel.setNewSelectedStatus(this.processConfigId, undefined, this.isReadonly);
                    this.draw();
                },
                "Status could not be deleted");
        }

        public updateStatusGroup(statusCodeId: string, status: Wars.Domain.Model.Dtos.Workflow.StatusDto): void {
            this.workflowService.updateStatus(statusCodeId, status).then(
                (processStatusGroup) => {
                    for (let i = 0; i < this.processStatusGroups.length; i++) {

                        if (this.processStatusGroups[i].processStatusGroupDto.id === statusCodeId) {
                            this.processStatusGroups[i] = processStatusGroup;
                        }

                        for (var x = 0; x < this.processStatusGroups[i].workflowBlocks.length; x++) {
                            if (this.processStatusGroups[i].workflowBlocks[x].type === Wars.Domain.Model.Codes.Enums.BlockType.StatusChange) {
                                var statusChangeWorkflowBlock = <StatusChangeWorkflowBlock>this.processStatusGroups[i].workflowBlocks[x];
                                if (statusChangeWorkflowBlock.toStatusGroupId === statusCodeId) {
                                    statusChangeWorkflowBlock.label = status.statusName;
                                }
                            }
                        }
                    }
                    this.draw();
                });
        }

        private redrawConnections(): void {
            var statusConnections = StatusConnections.createStatusConnectionObjects(this.processStatusGroups);
            this.removeAllLinks();
            this.drawAllLinks(statusConnections);
        }

        private updateSelectedStatusGroup(blocks: models.IWorkflowBlock[]): void {
            this.workflowWorkspaceModel.getSelectedStatusGroup().workflowBlocks = blocks;
        }

        private initialize(processStatusGroups: models.ProcessStatusGroup[], isReadonly: boolean): void {

            this.processStatusGroups = processStatusGroups;
            this.isReadonly = isReadonly;

            var numberOfStatuses = this.processStatusGroups.length;
            this.drawingOptions = this.getDrawingOptions(numberOfStatuses);
            this.graph = new joint.dia.Graph();

            var paperOptions = {
                el: $('#workflowDiagram'),
                width: Math.max($(window).width(), this.drawingOptions.calculateWidthRequired()),
                height: this.drawingOptions.calculateHeightRequired(),
                gridSize: this.drawingOptions.gridSize,
                model: this.graph,
                interactive: this.interactive
            };

            var resizeHanlder = $(window).resize(() => {
                var newWidth = Math.max($(window).width(), this.drawingOptions.calculateWidthRequired());
                this.paper.setDimensions(newWidth, this.paper.options.height);
                this.draw();
            });

            var listenerCallback = this.$scope.$on('$locationChangeStart', function (event) {
                resizeHanlder.off();
            });

            this.$scope.$on("$destroy", () => {
                listenerCallback();
            });

            this.paper = new joint.dia.Paper(paperOptions);
            this.draw();
        }

        private draw(): void {
            this.graph.clear();

            this.elementMapping = [];

            this.registerMoveHandlerToKeepElementsOnPaper(this.paper, this.drawingOptions);
            this.registerSelectOnDoubleClickHandler(this.paper, this.graph, this.drawingOptions);

            var rectangles = [];
            for (var i = 0; i < this.processStatusGroups.length; i++) {
                var text = this.processStatusGroups[i].processStatusGroupDto.statusName;
                if (text.length > 13) {
                    var index = text.indexOf(" ");
                    if (index !== -1) {
                        text = text.replace(" ", "\n");
                    } else {
                        text = text.substr(0, 13) + "-\n" + text.substr(13);
                    }
                }

                var rectangleOptions = {
                    position: { x: this.drawingOptions.calculateHorizontalPosition(i), y: this.drawingOptions.verticalSpacing },
                    size: { width: this.drawingOptions.boxWidth, height: this.drawingOptions.boxHeight },

                    attrs: {
                        rect: {
                            class: 'state-workflow-block',
                            rx: '5',
                            ry: '5'
                        },
                        text: {
                            text: text,
                            class: 'text'
                        }
                    }
                }

                var rectangle = new joint.shapes.basic.Rect(rectangleOptions);
                this.elementMapping.push(new models.jointJs.ElementMap(this.processStatusGroups[i].processStatusGroupDto.id, rectangle.id));
                rectangles.push(rectangle);
            }

            this.graph.addCells(rectangles);
            
            this.drawAllLinks(models.StatusConnections.createStatusConnectionObjects(this.processStatusGroups));
        }

        private drawAllLinks(statusConnections: StatusConnections[]): void {
            var links = [];
            for (var i = 0; i < statusConnections.length; i++) {
                var currentStatus = statusConnections[i];

                for (var index = 0; index < currentStatus.toStatusGroupIds.length; index++) {
                    var linkOptions = {
                        source: {
                            id: Enumerable.from(this.elementMapping).single(i => i.entityId === currentStatus.statusCodeId).elementId,
                            port: 'out'
                        },
                        target: {
                            id: Enumerable.from(this.elementMapping).single(i => i.entityId === currentStatus.toStatusGroupIds[index]).elementId,
                            port: 'in'
                        }
                    };
                    var link = new joint.dia.Link(linkOptions);
                    link.attr({
                        '.connection': { 'fill-opacity': 0 },
                        '.connection-wrap': { 'fill-opacity': 0 },
                        '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z' }
                    });

                    link.set('router', { name: 'manhattan' });
                    //link.set('manhattan', true)
                    links.push(link);
                }
            }

            this.graph.addCells(links);
            links.forEach((link) => link.toBack());
        }

        private removeAllLinks(): void {
            for (var i = 0; i < this.elementMapping.length; i++) {
                var cell = this.getJointjsCellByStatusGroupId(this.elementMapping[i].entityId);
                this.graph.removeLinks(cell);
            }
        }

        private getJointjsCellByStatusGroupId(id: string): joint.dia.Cell {
            var elementId = Enumerable.from(this.elementMapping).single(i => i.entityId == id).elementId;
            var graphAny: any = this.graph;
            return graphAny.getCell(elementId);
        }

        private getDrawingOptions(numberOfBoxes: number): models.jointJs.DrawingOptions {
            var drawingOptions = new models.jointJs.DrawingOptions();

            drawingOptions.numberOfBoxes = numberOfBoxes;

            drawingOptions.boxWidth = 100;
            drawingOptions.boxHeight = 50;

            drawingOptions.verticalSpacing = 20;
            drawingOptions.horizontalSpacing = 20;

            drawingOptions.gridSize = 1;

            drawingOptions.rectangleColor = 'maroon';
            drawingOptions.textColor = 'white';

            drawingOptions.selectedRectangleColor = 'yellow';
            drawingOptions.selectedTextColor = 'black';

            return drawingOptions;
        }

        private interactive(cellView: any): any {
            if (cellView.model instanceof joint.dia.Link) {
                // Disable the default vertex add functionality on pointerdown.
                return {
                    vertexAdd: false,
                    vertexMove: false,
                    vertexRemove: false,
                    arrowheadMove: false
                };
            }
            return true;
        }

        private registerMoveHandlerToKeepElementsOnPaper(paper: any, drawingOptions: models.jointJs.DrawingOptions) {
            paper.on('cell:pointermove', (cellView, evt, x, y) => {

                var bbox = cellView.getBBox();
                var constrained = false;
                var width = this.paper.options.width;

                var constrainedX = x;

                if (bbox.x <= 0) { constrainedX = x + drawingOptions.gridSize; constrained = true }
                if (bbox.x + bbox.width >= width) { constrainedX = x - drawingOptions.gridSize; constrained = true }

                var constrainedY = y;

                if (bbox.y <= 0) { constrainedY = y + drawingOptions.gridSize; constrained = true }
                if (bbox.y + bbox.height >= drawingOptions.calculateHeightRequired()) { constrainedY = y - drawingOptions.gridSize; constrained = true }

                //if you fire the event all the time you get a stack overflow
                if (constrained) { cellView.pointermove(evt, constrainedX, constrainedY) }
            });
        }

        private registerSelectOnDoubleClickHandler(paper: any, graph: any, drawingOptions: models.jointJs.DrawingOptions) {
            var self = this;
            paper.on('cell:pointerdblclick', (cellView) => {
                var model = cellView.model;
                if (!model) return;
                var attributes = model.attributes;
                if (!attributes || attributes.type !== 'basic.Rect') return;

                self.unselectAllBoxes(graph, drawingOptions);

                model.attr('rect/class', 'selected-state-workflow-block');
                
                var statusCodeId = Enumerable.from(self.elementMapping).single(i => i.elementId === model.id).entityId;
                self.workflowWorkspaceModel.scope.$apply(() => {

                    var processStatusGroup = Enumerable.from(self.processStatusGroups).single(i => i.processStatusGroupDto.id === statusCodeId);
                    self.workflowWorkspaceModel.setNewSelectedStatus(self.processConfigId, processStatusGroup, self.isReadonly);

                    self.workflowWorkspaceModel.drawWorkflow();
                    self.workflowWorkspaceModel.drawShapesForToolbox();

                    self.workflowWorkspaceModel.settings.xOrigin = 0;
                    self.workflowWorkspaceModel.settings.yOrigin = 0;
                    self.workflowWorkspaceModel.changeViewBoxSizeAndOffset();
                });
            });
        }

        private getWorkflowWorkspaceSettings() : models.WorkflowDrawingSettings {
            return new models.WorkflowDrawingSettings(3200, 1800);
        }

        private unselectAllBoxes(graph: any, drawingOptions: models.jointJs.DrawingOptions) : void {
            for (var i = 0; i < this.elementMapping.length; i++) {
                var currentMap = this.elementMapping[i];
                var cell = graph.getCell(currentMap.elementId);
                cell.attr('rect/class', 'state-workflow-block');
            }
        }

        private showAddEditStatusModal(existingStatusGroup: boolean): void {
            var self: WorkflowConfigurationModel = this;
            var model: models.AddEditStatusModel;

            if (existingStatusGroup) {
                model = new models.AddEditStatusModel(this.workflowWorkspaceModel.getSelectedStatusGroup());
            } else {
                model = new models.AddEditStatusModel();
                if (this.processStatusGroups == null || this.processStatusGroups === undefined || this.processStatusGroups.length === 0) {
                    model.processStatusGroup.processStatusGroupDto.isInitialStatus = true;
                }
            }
           
            this.modalService.showModal({
                templateUrl: "./app/views/modals/workflow/_addEditStatus.html",
                controller: "addEditStatusModalController",
                inputs: {
                    model: model
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        if (model.existingStatus) {
                            if (model.deleteStatusCode) {
                                self.deleteStatusCode(this.workflowWorkspaceModel.getSelectedStatusGroup().processStatusGroupDto.id);
                            } else {
                                self.updateStatusGroup(this.workflowWorkspaceModel.getSelectedStatusGroup().processStatusGroupDto.id, model.processStatusGroup.processStatusGroupDto);
                            }
                            
                        } else {
                            self.addNewStatus(model.processStatusGroup.processStatusGroupDto);
                        }
                    }
                });
            });
        }
    }
}